// extracted by mini-css-extract-plugin
export default {"tabListItem":"dR_n7","active":"dR_bL","searchActive":"dR_n8","lottoTabsActive":"dR_n9","sportstakeTabsActive":"dR_pb"};